import { Injectable } from '@angular/core';
import {AlertController, ToastController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  duration: number = 4000;

  constructor(private toastController: ToastController, private alertController: AlertController) { }

  async validationError(error: any)
  {
    let title = error?.detail ? error?.detail : 'Input validation failed';
    let message = 'Please fix the errors and try again';

    // Loop through the errors
    if (error?.errors)
    {
      message += '<ul>';
      for (const property in  error?.errors)
      {
        message += `<li>${error?.errors[property][0].message}</li>`
      }
      message += '</ul>';
    }

    const alert = await this.alertController.create({
      header: title,
      // subHeader: 'A Sub Header Is Optional',
      message: message,
      buttons: ['Ok'],
    });

    await alert.present();
  }

  async success(message: string)
  {
    const toast = await this.toastController.create({
      message: message,
      duration: this.duration,
      position: 'bottom',
      icon: 'checkmark-circle-sharp',
      color: 'success'
    });

    await toast.present();
  }

  async error(message: string)
  {
    const toast = await this.toastController.create({
      message: message,
      duration: this.duration,
      position: 'bottom',
      icon: 'alert-circle-sharp',
      color: 'danger'
    });

    await toast.present();
  }
}
